// extracted by mini-css-extract-plugin
export default {"title":"H_-z","warning":"I_-z","sizeOptionsLegendText":"J_-z"};